// 活动传参 会员节固定值
export const activityId = '3';
// 能量最大值
export const MAX_ENERGY: Record<string, number> = {
    us: 10000000,
    ca: 1000000,
    jp: 450000,
    eu: 1000000,
    uk: 600000,
    de: 3500000,
    fr: 1500000,
    es: 450000,
    it: 250000,
    kr: 200000,
    au: 350000,
    za: 200000,
};
// 千分位分割符
export const partition: Record<string, string> = {
    de: ' ',
    fr: ' ',
    es: ' ',
    it: '.',
};

// 产品图片
export const productImgList: Record<string, [string, string]> = {
    us: ['https://websiteoss.ecoflow.com/upload/image/1741607059598/d2.png', 'https://websiteoss.ecoflow.com/upload/image/1741607082955/d2max.png'],
    ca: ['https://websiteoss.ecoflow.com/upload/image/1742541373609/r3p.png', 'https://websiteoss.ecoflow.com/upload/image/1741607059598/d2.png'],
    jp: ['https://websiteoss.ecoflow.com/upload/image/1742541489458/d3p.png', 'https://websiteoss.ecoflow.com/upload/image/1742541505828/d2m.png'],
    eu: ['https://websiteoss.ecoflow.com/upload/image/1743057626387/r3.png', 'https://websiteoss.ecoflow.com/upload/image/1743057668831/d3.png'],
    uk: ['https://websiteoss.ecoflow.com/upload/image/1742541623627/r3.png', 'https://websiteoss.ecoflow.com/upload/image/1742541634390/d3.png'],
    de: ['https://websiteoss.ecoflow.com/upload/image/1743057626387/r3.png', 'https://websiteoss.ecoflow.com/upload/image/1743057668831/d3.png'],
    fr: ['https://websiteoss.ecoflow.com/upload/image/1743057626387/r3.png', 'https://websiteoss.ecoflow.com/upload/image/1743057668831/d3.png'],
    es: ['https://websiteoss.ecoflow.com/upload/image/1743057626387/r3.png', 'https://websiteoss.ecoflow.com/upload/image/1743057668831/d3.png'],
    it: ['https://websiteoss.ecoflow.com/upload/image/1743057626387/r3.png', 'https://websiteoss.ecoflow.com/upload/image/1743057668831/d3.png'],
    kr: ['https://websiteoss.ecoflow.com/upload/image/1743057354435/kr-r3.png', 'https://websiteoss.ecoflow.com/upload/image/1743057378830/kr-d3.png'],
    au: ['https://websiteoss.ecoflow.com/upload/image/1742541971866/r3.png', 'https://websiteoss.ecoflow.com/upload/image/1742541990276/d2.png'],
    za: ['https://websiteoss.ecoflow.com/upload/image/1742542071065/rp.png', 'https://websiteoss.ecoflow.com/upload/image/1742542082557/d2.png'],
};
